import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '@src/app/shared/shared.module';
import { AnalysisMetrics } from '@features/dashboard/document-analysis-company/helpers/document-analysis-metrics';

@Component({
  selector: 'app-analysis-footer-bar',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './analysis-footer-bar.component.html',
  styleUrls: ['./analysis-footer-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalysisFooterBarComponent {
  @Input({ required: true }) metrics!: AnalysisMetrics;
  @Input() finalizeLabel = 'Finalizar análise';
  @Output() finalize = new EventEmitter<void>();

  @Input() approveAllLabel = 'Aprovar todos';
  @Input() isApprovingAll = false;
  @Output() approveAll = new EventEmitter<void>();

  /**
   * A ação só existe quando há algo a aprovar. Diferente de "Finalizar análise", que fica sempre
   * habilitado por decisão do redesign e valida no clique: aqui zero pendentes significa que não
   * há nada para a ação fazer, então o botão desabilita (critério 9 do card 2896).
   */
  get canApproveAll(): boolean {
    return this.metrics.pending > 0 && !this.isApprovingAll;
  }

  get pendingHint(): string {
    const pending = this.metrics.pending;

    if (pending === 0) {
      return 'Todos os documentos foram analisados';
    }

    return pending === 1
      ? '1 documento ainda sem decisão'
      : `${pending} documentos ainda sem decisão`;
  }
}
